<template>
  <div id="printable" class="summary-container">
    <!-- Header -->
    <div class="header">
      <div class="facility-name">
        TUURU COTTOLENGO HEALTH CENTRE - AR2026259
      </div>
      <div class="facility-details">
        <div>Igembe Central</div>
        <div>P.O BOX 77 - Meru | Tel: 254254746758069</div>
        <div>Email: suore.tuuru@cottolengo.org</div>
      </div>
      <div class="register-title">
        MOH 705A - UNDER FIVE OUTPATIENT MORBIDITY SUMMARY SHEET
      </div>
    </div>

    <!-- Month/Year and Generated By Bar -->
    <div class="info-bar">
      <div class="info-left">
        <div class="info-item">
          <span class="info-label">Month:</span>
          <span class="info-value">{{ month }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">Year:</span>
          <span class="info-value">{{ year }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">Generated By:</span>
          <span class="info-value">{{ generatedBy }}</span>
        </div>
      </div>
      <button @click="printPage" class="btn-print">🖨️ Print Summary</button>
    </div>

    <!-- Summary Table -->
    <div class="table-wrapper">
      <table class="summary-table">
        <thead>
          <tr>
            <th rowspan="2" class="sno-col">Sno</th>
            <th rowspan="2" class="disease-col">DISEASES (New Cases Only)</th>
            <th colspan="31" class="days-header">
              DAY OF THE MONTH - {{ month }} {{ year }}
            </th>
            <th rowspan="2" class="total-col"># TOTALS</th>
          </tr>
          <tr>
            <th class="dys" v-for="day in 31" :key="day">{{ day }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(disease, index) in diseases" :key="index">
            <td class="sno-cell">{{ disease.sno }}</td>
            <td class="disease-cell">{{ disease.name }}</td>
            <td v-for="day in 31" :key="'d' + index + day" class="day-cell">
              <span class="day-value">{{ disease.days[day - 1] }}</span>
            </td>
            <td class="total-cell">{{ disease.total }}</td>
          </tr>

          <!-- Summary Rows -->
          <tr
            class="summary-row"
            v-for="summary in summaryRows"
            :key="summary.sno"
          >
            <td class="sno-cell">{{ summary.sno }}</td>
            <td class="disease-cell">{{ summary.name }}</td>
            <td
              v-for="day in 31"
              :key="'sum' + summary.sno + day"
              class="day-cell"
            >
              <span class="day-value">{{ summary.days[day - 1] }}</span>
            </td>
            <td class="total-cell">{{ summary.total }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "MOH705ASummary",
  data() {
    return {
      month: "April",
      year: "2026",
      generatedBy: "SR. JANE KAREGI MUNYUGI",
      diseases: [
        {
          sno: 1,
          name: "Diarrhoea with no dehydration",
          days: Array(31).fill(0),
          total: 0,
        },
        {
          sno: 2,
          name: "Diarrhoea with some dehydration",
          days: Array(31).fill(0),
          total: 0,
        },
        {
          sno: 3,
          name: "Diarrhoea with severe dehydration",
          days: Array(31).fill(0),
          total: 0,
        },
        {
          sno: 4,
          name: "Presumed Tuberculosis",
          days: Array(31).fill(0),
          total: 0,
        },
        { sno: 5, name: "Gastroenteritis", days: Array(31).fill(0), total: 0 },
        {
          sno: 6,
          name: "Dysentery (Bloody diarrhoea)",
          days: Array(31).fill(0),
          total: 0,
        },
        { sno: 7, name: "Cholera", days: Array(31).fill(0), total: 0 },
        {
          sno: 8,
          name: "Meningococcal Meningitis",
          days: Array(31).fill(0),
          total: 0,
        },
        { sno: 9, name: "Other Meningitis", days: Array(31).fill(0), total: 0 },
        { sno: 10, name: "Tetanus", days: Array(31).fill(0), total: 0 },
        {
          sno: 11,
          name: "Poliomyelitis (AFP)",
          days: Array(31).fill(0),
          total: 0,
        },
        { sno: 12, name: "Chicken Pox", days: Array(31).fill(0), total: 0 },
        { sno: 13, name: "Measles", days: Array(31).fill(0), total: 0 },
        { sno: 14, name: "Hepatitis", days: Array(31).fill(0), total: 0 },
        { sno: 15, name: "Mumps", days: Array(31).fill(0), total: 0 },
        {
          sno: 16,
          name: "Suspected Malaria",
          days: Array(31).fill(0),
          total: 0,
        },
        {
          sno: 17,
          name: "Confirmed malaria",
          days: Array(31).fill(0),
          total: 0,
        },
        { sno: 18, name: "Amoebiasis", days: Array(31).fill(0), total: 0 },
        { sno: 19, name: "Typhoid fever", days: Array(31).fill(0), total: 0 },
        {
          sno: 20,
          name: "Urinary Tract Infections",
          days: Array(31).fill(0),
          total: 0,
        },
        {
          sno: 21,
          name: "Bilharzia (Schistosomiasis)",
          days: Array(31).fill(0),
          total: 0,
        },
        {
          sno: 22,
          name: "Intestinal worms",
          days: Array(31).fill(0),
          total: 0,
        },
        { sno: 23, name: "Pneumonia", days: Array(31).fill(0), total: 0 },
        {
          sno: 24,
          name: "Severe pneumonia",
          days: Array(31).fill(0),
          total: 0,
        },
        {
          sno: 25,
          name: "Upper Respiratory Tract Infections",
          days: Array(31).fill(0),
          total: 0,
        },
        {
          sno: 26,
          name: "Lower Respiratory Tract Infections",
          days: Array(31).fill(0),
          total: 0,
        },
        { sno: 27, name: "Asthma", days: Array(31).fill(0), total: 0 },
        { sno: 28, name: "Ear infection", days: Array(31).fill(0), total: 0 },
        { sno: 29, name: "Malnutrition", days: Array(31).fill(0), total: 0 },
        { sno: 30, name: "Anaemia", days: Array(31).fill(0), total: 0 },
        { sno: 31, name: "Neonatal Sepsis", days: Array(31).fill(0), total: 0 },
        {
          sno: 32,
          name: "Neonatal Tetanus",
          days: Array(31).fill(0),
          total: 0,
        },
        { sno: 33, name: "Eye Infections", days: Array(31).fill(0), total: 0 },
        { sno: 34, name: "Tonsilitis", days: Array(31).fill(0), total: 0 },
        {
          sno: 35,
          name: "Mental Disorders",
          days: Array(31).fill(0),
          total: 0,
        },
        {
          sno: 36,
          name: "Dental Disorders",
          days: Array(31).fill(0),
          total: 0,
        },
        {
          sno: 37,
          name: "Jiggers Infestation",
          days: Array(31).fill(0),
          total: 0,
        },
        {
          sno: 38,
          name: "Diseases of the skin",
          days: Array(31).fill(0),
          total: 0,
        },
        { sno: 39, name: "Down's syndrome", days: Array(31).fill(0), total: 0 },
        { sno: 40, name: "Poisoning", days: Array(31).fill(0), total: 0 },
        {
          sno: 41,
          name: "Road Traffic Injuries",
          days: Array(31).fill(0),
          total: 0,
        },
        {
          sno: 42,
          name: "Deaths due to Road Traffic Injuries",
          days: Array(31).fill(0),
          total: 0,
        },
        {
          sno: 43,
          name: "Violence related injuries",
          days: Array(31).fill(0),
          total: 0,
        },
        { sno: 44, name: "Other injuries", days: Array(31).fill(0), total: 0 },
        { sno: 45, name: "Sexual Violence", days: Array(31).fill(0), total: 0 },
        { sno: 46, name: "Burns", days: Array(31).fill(0), total: 0 },
        { sno: 47, name: "Snake Bites", days: Array(31).fill(0), total: 0 },
        { sno: 48, name: "Dog Bites", days: Array(31).fill(0), total: 0 },
        { sno: 49, name: "Other Bites", days: Array(31).fill(0), total: 0 },
        { sno: 50, name: "Diabetes", days: Array(31).fill(0), total: 0 },
        { sno: 51, name: "Epilepsy", days: Array(31).fill(0), total: 0 },
        { sno: 52, name: "Rheumatic Fever", days: Array(31).fill(0), total: 0 },
        { sno: 53, name: "Brucellosis", days: Array(31).fill(0), total: 0 },
        { sno: 54, name: "Rickets", days: Array(31).fill(0), total: 0 },
        { sno: 55, name: "Cerebral Palsy", days: Array(31).fill(0), total: 0 },
        { sno: 56, name: "Autism", days: Array(31).fill(0), total: 0 },
        { sno: 57, name: "Tryponosomiasis", days: Array(31).fill(0), total: 0 },
        { sno: 58, name: "Yellow Fever", days: Array(31).fill(0), total: 0 },
        {
          sno: 59,
          name: "Viral Haemorrhagic Fever",
          days: Array(31).fill(0),
          total: 0,
        },
        {
          sno: 60,
          name: "Rift valley fever",
          days: Array(31).fill(0),
          total: 0,
        },
        { sno: 61, name: "Chikungunya", days: Array(31).fill(0), total: 0 },
        { sno: 62, name: "Dengue fever", days: Array(31).fill(0), total: 0 },
        {
          sno: 63,
          name: "Leishmaniasis(Kalaazar)",
          days: Array(31).fill(0),
          total: 0,
        },
        {
          sno: 64,
          name: "Cutaneous leishmaniasis",
          days: Array(31).fill(0),
          total: 0,
        },
        { sno: 65, name: "anthrax", days: Array(31).fill(0), total: 0 },
        {
          sno: 66,
          name: "Suspected Childhood Cancers",
          days: Array(31).fill(0),
          total: 0,
        },
        {
          sno: 67,
          name: "Hypoxaemia (Spo2<90%)",
          days: Array(31).fill(0),
          total: 0,
        },
        { sno: 68, name: "Plague", days: Array(31).fill(0), total: 0 },
        { sno: 69, name: "Arthritis", days: Array(31).fill(0), total: 0 },
        {
          sno: 70,
          name: "Tested For Malaria",
          days: Array(31).fill(0),
          total: 0,
        },
        { sno: 71, name: "Gastritis", days: Array(31).fill(0), total: 0 },
        {
          sno: 72,
          name: "All Other diseases",
          days: Array(31).fill(0),
          total: 0,
        },
      ],
      summaryRows: [
        {
          sno: 74,
          name: "NO. OF FIRST ATTENDANCES",
          days: Array(31).fill(0),
          total: 0,
        },
        { sno: 75, name: "RE-ATTENDANCES", days: Array(31).fill(0), total: 0 },
        {
          sno: 76,
          name: "REFERRALS FROM OTHER HEALTH FACILITY",
          days: Array(31).fill(0),
          total: 0,
        },
        {
          sno: 77,
          name: "REFERRALS TO OTHER HEALTH FACILITY",
          days: Array(31).fill(0),
          total: 0,
        },
      ],
    };
  },
  methods: {
    printPage() {
      window.print();
    },
  },
  mounted() {
    // Calculate totals
    this.diseases.forEach((disease) => {
      disease.total = disease.days.reduce(
        (sum, val) => sum + (parseInt(val) || 0),
        0,
      );
    });
    this.summaryRows.forEach((summary) => {
      summary.total = summary.days.reduce(
        (sum, val) => sum + (parseInt(val) || 0),
        0,
      );
    });
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.summary-container {
  background: white;
  min-height: 100vh;
  padding: 20px;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

/* Header */
.header {
  text-align: center;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid #1a56db;
}

.facility-name {
  font-size: 20px;
  font-weight: bold;
  color: #1a56db;
  margin-bottom: 6px;
}

.facility-details {
  font-size: 11px;
  color: #4b5563;
  line-height: 1.4;
  margin-bottom: 10px;
}

.register-title {
  font-size: 14px;
  font-weight: bold;
  background: #f3f4f6;
  display: inline-block;
  padding: 5px 16px;
  border-radius: 20px;
  color: #1f2937;
}

/* Info Bar */
.info-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 20px;
  padding: 10px 16px;
  background: #f9fafb;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
}

.info-left {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 6px;
}

.info-label {
  font-size: 12px;
  font-weight: 600;
  color: #374151;
}

.info-value {
  font-size: 12px;
  color: #1f2937;
  font-weight: 500;
}

.btn-print {
  padding: 8px 20px;
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.2s;
}

.btn-print:hover {
  background: #2563eb;
}

/* Table Wrapper */
.table-wrapper {
  overflow-x: auto;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  max-height: 70vh;
  overflow-y: auto;
}

.summary-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 10px;
  min-width: 1400px;
}

.summary-table th {
  background: #1f2937;
  color: white;
  padding: 8px 4px;
  font-weight: 600;
  text-align: center;
  border: 1px solid #374151;
  position: sticky;
  top: 0;
  z-index: 10;
}

.summary-table th.days-header {
  background: #374151;
}

.sno-col {
  width: 45px;
}

.disease-col {
  width: 220px;
  text-align: left;
  padding-left: 8px !important;
}

.total-col {
  width: 70px;
  background: #059669;
}

.summary-table td {
  border: 1px solid #d1d5db;
  padding: 6px 2px;
  text-align: center;
}

.sno-cell {
  background: #f3f4f6;
  font-weight: 500;
  text-align: center;
}

.disease-cell {
  text-align: left;
  padding-left: 8px;
  font-size: 9px;
  background: white;
}

.day-cell {
  padding: 2px;
}

.day-value {
  display: inline-block;
  min-width: 30px;
  font-size: 10px;
  font-weight: 500;
  color: #1f2937;
}

.total-cell {
  background: #ecfdf5;
  font-weight: 600;
  font-size: 10px;
  color: #065f46;
}

.summary-row {
  background: #fffbeb;
}

.summary-row .disease-cell {
  font-weight: 600;
  background: #fffbeb;
}

/* Print Styles */
@media print {
  @page {
    size: landscape;
    margin: 0.3cm;
  }

  body {
    margin: 0;
    padding: 0;
  }

  .btn-print {
    display: none;
  }

  .summary-container {
    padding: 0.2cm;
    margin: 0;
  }

  .header {
    margin-bottom: 5px;
    padding-bottom: 5px;
  }

  .facility-name {
    font-size: 14px;
  }

  .facility-details {
    font-size: 8px;
  }

  .register-title {
    font-size: 10px;
    padding: 2px 10px;
  }

  .info-bar {
    margin-bottom: 8px;
    padding: 5px 10px;
    background: #f3f4f6;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .info-label,
  .info-value {
    font-size: 9px;
  }

  .table-wrapper {
    overflow: visible !important;
    border: none;
    max-height: none;
  }

  .summary-table {
    font-size: 7px;
    min-width: 0 !important;
    width: 100%;
  }

  .summary-table th thead {
    padding: 3px 2px;
    font-size: 7px;
    background: #e5e7eb !important;
    color: black !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .summary-table td {
    padding: 3px 1px;
  }

  .disease-col {
    width: 180px;
  }

  .disease-cell {
    font-size: 6.5px;
    padding-left: 3px;
  }

  .day-value {
    font-size: 7px;
    min-width: 20px;
  }

  .total-cell {
    font-size: 7px;
  }
}
</style>
